import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_PROCESOS_JURIDICOS

export default class FallosService {
  paginate (params) {
    return http.get(`${baseUrl}/fallos/paginate`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  search (params) {
    return http.get(`${baseUrl}/fallos/search`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  save (payload) {
    return http.post(`${baseUrl}/fallos`, payload, {
      headers: {
        loading: true
      }
    })
  }

  find (id) {
    return http.get(`${baseUrl}/fallos/${id}`, {
      headers: {
        loading: true
      }
    })
  }

  edit (payload, id) {
    return http.put(`${baseUrl}/fallos/${id}`, payload, {
      headers: {
        loading: true
      }
    })
  }

  remove (id) {
    return http.delete(`${baseUrl}/fallos/${id}`, {
      headers: {
        loading: true
      }
    })
  }

  findFalloByTutela (id) {
    return http.get(`${baseUrl}/fallos/fallos-by-tutela/${id}`, {
      headers: {
        loading: true
      }
    })
  }
}
